// Service worker registration with user-controlled updates.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).then((reg) => {
      const announce = () => { if (reg.waiting && navigator.serviceWorker.controller) window.dispatchEvent(new CustomEvent("sw-update", { detail: reg })); };
      announce();
      reg.addEventListener("updatefound", () => {
        const w = reg.installing;
        w?.addEventListener("statechange", () => { if (w.state === "installed") announce(); });
      });
      // check for a new version whenever the app comes back to the foreground
      document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") reg.update().catch(() => undefined); });
    }).catch(() => undefined);
  });
}

export function applyUpdate(reg: ServiceWorkerRegistration) {
  navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload(), { once: true });
  reg.waiting?.postMessage({ type: "SKIP_WAITING" });
}

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || (navigator as unknown as { standalone?: boolean }).standalone === true;
